import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const GenericMessageError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="generic-message-error" severity="error">
            {t('formErrors.genericErrorMessage.errorOccured')}
        </Alert>
    );
};
